export enum OrganizationName {
    COLLECTIONS = 'collections',
    YUBI = 'yubi',
}

export interface Organization {
    name: OrganizationName;
    email: string;
    logo: string;
    terms: string;
    website: string;
    copyrights: string;
    brand: string;
    socials: {
        fb: string;
        tweeter: string;
        linkedin: string;
    };
    signInUrl: string;
}
